import React, { useEffect, useState, useRef } from "react";
import { Button, Alert, Modal} from 'antd';
import { QrcodeOutlined } from '@ant-design/icons';
import { Html5QrcodeScanner } from "html5-qrcode";

const QRScanner = ({ onScan }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [error, setError] = useState("");
    const scannerRef = useRef(null);
  
    useEffect(() => {
      if (isModalOpen) {
        if (!scannerRef.current) {
          scannerRef.current = new Html5QrcodeScanner("reader", { fps: 10, qrbox: 250 });
  
          scannerRef.current.render(
            (decodedText) => {
              try {
                const decodedString = atob(decodedText)
                const scannedData = JSON.parse(decodedString);
                onScan(scannedData);
                handleCloseModal();
              } catch {
                setError("Invalid QR Code format");
              }
            },
            (err) => console.warn("QR scan error:", err)
          );
        }
      }
  
      return () => {
        if (scannerRef.current) {
          scannerRef.current.clear();
          scannerRef.current = null;
        }
      };
    }, [isModalOpen]);
  
    const handleOpenModal = () => {
      setError("");
      setIsModalOpen(true);
    };
  
    const handleCloseModal = () => {
      setIsModalOpen(false);
    };
  
    return (
      <>
        <Button type="primary" onClick={handleOpenModal}><QrcodeOutlined /> Scan QR Code</Button>
        <Modal open={isModalOpen} onCancel={handleCloseModal} footer={null}>
          {error && <Alert message={error} type="error" showIcon />}
          <div id="reader" style={{ width: "100%" }} />
        </Modal>
      </>
    );
};

export default QRScanner;